module.exports = __webpack_public_path__ + "media/icons/check-on@2x-57e054bb.png";